var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppstoreModal = function SvgAppstoreModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "appstore_modal_svg__mask0_32885_63279",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 88,
    height: 79
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8413 12.5322L46.2903 8.28496C47.8021 5.63046 51.1733 4.73551 53.8189 6.25237C56.4645 7.76923 57.3565 11.1518 55.8447 13.8063L32.246 54.7919H49.3139C54.8469 54.7919 57.9461 61.3144 55.5423 65.8346H5.50283C2.44906 65.8346 0 63.3773 0 60.3133C0 57.2492 2.44906 54.7919 5.50283 54.7919H19.532L37.4918 23.5597L31.8832 13.7912C30.3714 11.1367 31.2634 7.7844 33.9089 6.2372C36.5545 4.72034 39.8955 5.61529 41.4376 8.26979L43.8413 12.5322ZM22.616 71.5229L17.3249 80.7302C15.8131 83.3847 12.4418 84.2797 9.79625 82.7628C7.15066 81.2459 6.25872 77.8633 7.77049 75.2088L11.7011 68.383C16.1457 67.0026 19.7588 68.0644 22.616 71.5229ZM68.1807 54.8222H82.4972C85.5509 54.8222 88 57.2795 88 60.3436C88 63.4077 85.5509 65.865 82.4972 65.865H74.5453L79.912 75.2088C81.4238 77.8633 80.5319 81.2156 77.8863 82.7628C75.2407 84.2797 71.8997 83.3847 70.3577 80.7302C61.3173 65.0004 54.5295 53.2295 50.0244 45.3874C45.4135 37.4087 48.7092 29.3997 51.9594 26.6845C55.5726 32.9036 60.9696 42.293 68.1807 54.8222Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#appstore_modal_svg__mask0_32885_63279)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#appstore_modal_svg__filter0_f_32885_63279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-58.6248 30.5097C-62.3569 31.4473 -64.1224 34.8728 -62.9094 38.8459C-59.4783 50.0839 -55.9923 61.3227 -52.6475 72.5597C-48.7662 85.394 -40.5976 87.6024 -16.3857 87.5705C39.3018 87.4323 95.4379 88.5329 151.464 89.2751C161.148 89.3921 167.841 85.7083 166.408 81.0498C157.373 51.686 148.331 22.2966 139.389 -7.07191C137.648 -12.7895 130.709 -17.0546 125.338 -15.7053L-58.6248 30.5097Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#appstore_modal_svg__filter1_f_32885_63279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6444 131.365C34.64 131.369 34.6352 131.362 34.6388 131.357C53.1211 105.481 79.0356 75.5392 109.612 45.0898C113.378 41.3429 117.203 37.5993 121.073 33.8565C124.585 30.4601 125.652 24.5007 123.484 20.206C120.26 13.8189 117.016 7.44727 113.748 1.0938C111.122 -4.01067 105.156 -4.39209 101.385 0.284142L24.6498 95.4372C21.8161 98.951 21.1763 104.231 23.1058 108.104C26.9633 115.846 30.7937 123.607 34.646 131.357C34.6473 131.36 34.6466 131.363 34.6444 131.365Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#appstore_modal_svg__filter2_f_32885_63279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.5892 85.1349C28.1794 49.5491 -2.08192 78.36 51.0356 31.4767C58.8872 24.5492 66.8547 17.5779 74.907 10.5724C78.6624 7.3052 78.6038 2.54331 74.3489 4.41151C63.8373 9.02682 44.9945 24.7835 32.2713 24.7834C19.283 24.7834 -2.02073 47.6726 -11.5266 58.6949C-14.4125 62.0412 -15.0467 67.1964 -13.2095 71.0423C-10.986 75.6967 -8.7887 80.3712 -6.5657 85.0284C-6.54915 85.063 -6.55963 85.1106 -6.5892 85.1349Z",
    fill: "#71BBFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#appstore_modal_svg__filter3_f_32885_63279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.231 66.04L47.8123 100.689L53.204 110.342L106.516 75.8612L115.051 50.8037L96.9623 50.2647L74.231 66.04Z",
    fill: "#0A9F68"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "appstore_modal_svg__filter0_f_32885_63279",
    x: -69.3843,
    y: -22.0513,
    width: 242.081,
    height: 117.424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.04762,
    result: "effect1_foregroundBlur_32885_63279"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "appstore_modal_svg__filter1_f_32885_63279",
    x: 15.9028,
    y: -9.08743,
    width: 114.798,
    height: 146.549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.04762,
    result: "effect1_foregroundBlur_32885_63279"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "appstore_modal_svg__filter2_f_32885_63279",
    x: -20.3413,
    y: -2.105,
    width: 104.073,
    height: 93.335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.04762,
    result: "effect1_foregroundBlur_32885_63279"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "appstore_modal_svg__filter3_f_32885_63279",
    x: 41.7173,
    y: 44.1694,
    width: 79.4288,
    height: 72.2676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.04762,
    result: "effect1_foregroundBlur_32885_63279"
  })))));
};
export default SvgAppstoreModal;